import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import HeaderProfileInfo from "./HeaderProfileInfo";

const Header = (props) => {
  const [, setSettings] = useState(null);

  useEffect(() => {
    console.count("Header rendered");

    let settings = localStorage.getItem("settings");
    if (settings) {
      setSettings(JSON.parse(settings));
    }
  }, []);

  return (
    <>
      {/* <HeaderLogoArea logo={settings?.logoUrl || process.env.REACT_APP_LOGO || logo} logoText={settings?.logoUrl || process.env.REACT_APP_LOGO ? null : logoText} /> */}
      {/* <HeaderTitleArea className="w-full" headerTitle={props.headerTitle} /> */}
      <HeaderProfileInfo notificationCount={props.notificationCount} logoutLabel={props.logoutLabel} onLogout={props.onLogout} user={props.user} />
    </>
  );
};

Header.propTypes = {
  user: PropTypes.object,
  onLogout: PropTypes.func,
  headerTitle: PropTypes.string,
  notificationCount: PropTypes.number,
  logoutLabel: PropTypes.string,
};

export default Header;
